import { render, staticRenderFns } from "./TodaysOrderHistory.vue?vue&type=template&id=6657ae84&"
import script from "./TodaysOrderHistory.vue?vue&type=script&lang=js&"
export * from "./TodaysOrderHistory.vue?vue&type=script&lang=js&"
import style0 from "./TodaysOrderHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports